t = require('views/internal/teacup-with-helpers')('sticker_select_item')

module.exports = ->
  t.mustacheBlock 'pending', ->
    t.img '.sticker-select-image.sticker-select-pending', { src: t.mustacheVar('url') }

  t.mustacheBlockInverted 'pending', ->
    t.img '.sticker-select-image.sticker-select-shadow', { src: t.mustacheVar('url') }
    t.img '.sticker-select-image.sticker-select-fixed', { src: t.mustacheVar('url') }
    t.img '.sticker-select-image.sticker-select-peel', { src: t.mustacheVar('url') }

  t.mustacheBlock 'id', ->
    t.span '.sticker-select-option.sticker-select-option-delete-button.js-delete-sticker', ->
      t.icon 'close', { class: 'sticker-select-option-icon' }
      t.span '.sticker-select-option-text.u-text-underline', ->
        t.format 'delete'

  t.mustacheBlock 'error', ->
    t.span '.sticker-select-option', ->
      t.span '.sticker-select-option-text', ->
        t.text t.mustacheVar('error')

  t.mustacheBlock 'pending', ->
    t.span '.sticker-select-option', ->
      t.span '.spinner.small.u-float-left', { style: 'margin-right: 4px;' }
      t.span '.sticker-select-option-text', ->
        t.format 'uploading-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/sticker_select_item.coffee